import PropTypes from 'prop-types';

import Heading from 'shopper/components/Heading';
import Text from 'shopper/components/Text';

import Image from 'components/Image';

import { getArticleImageLink } from 'lib/image';

import ArticleBadge from './ArticleBadge';
import ArticleInfo from './ArticleInfo';

import APP from 'constants/app';

const ArticleMainHeading = ({
  articleDescription,
  articleId,
  articleImage,
  articlePublished,
  articleTitle,
  categoryName,
  categorySlug,
  gaEventCategory,
  userName,
  userPhoto,
  userUsername,
}) => (
  <>
    <ArticleBadge
      categoryName={categoryName}
      categorySlug={categorySlug}
      gaEventCategory={gaEventCategory}
    />
    <Heading as="h1" size="size2">
      {articleTitle}
    </Heading>
    <Text className="mt-2 md:mt-4">{articleDescription}</Text>
    <Image
      alt={`Capa do artigo ${articleTitle}`}
      className="mt-6 hidden w-full rounded-2 md:mt-8 md:block lg:h-[554px]"
      height={405}
      loading={null}
      sizes="(max-width: 768px) 1px, 900px"
      src={getArticleImageLink(articleImage, 900)}
      srcSet={`
        ${APP.LOCAL_IMAGE_PATH}/general/placeholder.jpg 1w,
        ${getArticleImageLink(articleImage, 1200)} 1200w
      `}
      width={721}
      priority
    />
    <ArticleInfo
      articleId={articleId}
      articlePublished={articlePublished}
      articleTitle={articleTitle}
      gaEventCategory={gaEventCategory}
      userName={userName}
      userPhoto={userPhoto}
      userUsername={userUsername}
    />
  </>
);

ArticleMainHeading.propTypes = {
  articleDescription: PropTypes.string.isRequired,
  articleId: PropTypes.number.isRequired,
  articleImage: PropTypes.string.isRequired,
  articlePublished: PropTypes.string.isRequired,
  articleTitle: PropTypes.string.isRequired,
  categoryName: PropTypes.string.isRequired,
  categorySlug: PropTypes.string.isRequired,
  gaEventCategory: PropTypes.string.isRequired,
  userName: PropTypes.string.isRequired,
  userPhoto: PropTypes.string.isRequired,
  userUsername: PropTypes.string.isRequired,
};

export default ArticleMainHeading;
